import { C, SERIF, SANS } from "../lib/constants";
import { Eyebrow } from "../components/Primitives";
import { useSEO } from "../lib/useSEO";
import { SEO } from "../lib/seoRoutes";
import { PRIVACY, TERMS, UPDATED } from "../lib/legal";

function LegalLayout({ testid, eyebrow, title, sections }) {
  return (
    <div data-testid={testid} style={{ maxWidth: 780, margin: "0 auto", padding: "56px 28px 72px" }}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 style={{ fontFamily: SERIF, fontSize: 44, color: C.dark, fontWeight: 400, margin: "0 0 10px" }}>{title}</h1>
      <p style={{ fontFamily: SANS, fontSize: 12, color: C.muted, margin: "0 0 36px" }}>Last updated: {UPDATED}</p>
      {sections.map(([h, paras]) => (
        <section key={h} style={{ marginBottom: 28 }}>
          <h2 style={{ fontFamily: SERIF, fontSize: 22, color: C.dark, fontWeight: 400, margin: "0 0 10px" }}>{h}</h2>
          {paras.map((p, i) => (
            <p key={i} style={{ fontFamily: SANS, fontSize: 14, color: C.muted, lineHeight: 1.85, margin: "0 0 10px" }}>{p}</p>
          ))}
        </section>
      ))}
    </div>
  );
}

export function PrivacyPage() {
  useSEO(SEO.privacy);
  return <LegalLayout testid="privacy-page" eyebrow="Legal" title="Privacy Policy" sections={PRIVACY} />;
}

export function TermsPage() {
  useSEO(SEO.terms);
  return <LegalLayout testid="terms-page" eyebrow="Legal" title="Terms of Service" sections={TERMS} />;
}
